export const filtersSelector = (state) => state.filters.filters;
export const filtersIsCriteriaStrictSelector = (state) =>
  state.filters.isCriteriaStrict;
